import React, { FunctionComponent } from "react";

import { FakeComponentProps } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";

export type MemoFakeComponentProps = {
    /** Text zobrazovaný v komponentě */
    value: string;
} & FakeComponentProps;

const classNames = bemClassNames("memo-fake-component");

export const MemoFakeComponent: FunctionComponent<MemoFakeComponentProps> = ({
    value,
    onClick,
    onKeyDown,
    label,
    title,
    disabled,
    valueTitle,
    isEditing,
    ariaLabelledBy,
    required,
    recommended,
    postponedRequired,
}) => {
    const isDisabled = disabled || !isEditing;
    const isRequired = required && !isDisabled;
    const isPostponedRequired = postponedRequired && !required && !isDisabled;
    const isRecommended = recommended && !postponedRequired && !isRequired && !isDisabled;
    return (
        <div
            className={classNames({ disabled: isDisabled, required: isRequired, postponedRequired: isPostponedRequired, recommended: isRecommended })}
            {...{ title, onClick, onKeyDown }}
        >
            <textarea
                className={classNames("textarea")}
                title={valueTitle}
                readOnly={true}
                /* Uživatel může ve fake komponentě provést pouze smazání hodnoty pomocí kláves backspace/delete. Toto je zvláštní forma vstupu, která se zpracovává samostatně přes onKeyDown událost.
                Proto je textarea nastavená jako readonly, protože neumožňuje běžnou editaci. Z pohledu přístupnosti však není readonly nastavení zcela vhodné, protože uživatel by si myslel, že pole
                nelze editovat vůbec. Pole však lze editovat, jen je třeba provést nejdřív krok smazání. Proto je readonly atribut v textarea přepsán hodnotou aria-readonly nastavenou na false. */
                aria-readonly={false}
                aria-label={ariaLabelledBy ? undefined : label}
                aria-labelledby={ariaLabelledBy}
                {...{ disabled, value }}
            />
        </div>
    );
};
